<template>
  <div class="nav-wrap">
      <div class="banner-list">
        <el-carousel arrow="never" height="650px">
          <el-carousel-item v-for="(item,index) in list" :key="index" >
            <img :src="item.img" :alt="item.name" @click="swiperClick(item)">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: [Array, Object],
            default: () => []
        } 
    },
    methods: {
      // /点击
      swiperClick(v) {
        // type 1 url 直接跳转
        // 2 商品
        //  3 文章
        // 4  文章分类
        // 5 智能表单
      // window.open('https://www.baidu.com','_blank')
        if(v.type == 1) {
          window.open(v.val,'_blank')
          return
        }

        if(v.type == 2) {
          this.$router.push({
            name: 'detail',
            params: {goodsId: v.val}
            // path: `detail/${v.val}`,
          })
          return
        }
      },
    }
}
</script>

<style lang="scss" scoped>
.nav-wrap {
  width: 100%;
  position: relative;
  height: 650px;

  .banner-list {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 650px;
    z-index: 10;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>